export enum ItemConsumeType {
  Snapshot = 1, // snapResumeCount
}
